export const SUBSCRIPTION_TYPES = {
  STANDARD: {
    NOM: 'Стандартная подписка',
    GEN: 'Стандартной подписки',
    DAT: 'Стандартной подписке',
    ACC: 'Стандартную подписку',
    INS: 'Стандартной подпиской',
    PRE: 'Стандартной подписке',
  },
  PRO: {
    NOM: 'Премиум-подписка',
    GEN: 'Премиум-подписки',
    DAT: 'Премиум-подписке',
    ACC: 'Премиум-подписку',
    INS: 'Премиум-подпиской',
    PRE: 'Премиум-подписке',
  },
  AUDIO: {
    NOM: 'Премиум-подписка',
    GEN: 'Премиум-подписки',
    DAT: 'Премиум-подписке',
    ACC: 'Премиум-подписку',
    INS: 'Премиум-подпиской',
    PRE: 'Премиум-подписке',
  },
};

export const PAYMENT_METHODS = {
  CREDIT_CARD: {
    NOM: 'Карта',
    GEN: 'Карты',
    DAT: 'Карте',
    ACC: 'Карту',
    INS: 'Картой',
    PRE: 'Карте',
  },
  GIFT_CODE: {
    NOM: 'Подарочный код',
    GEN: 'Подарочного кода',
    DAT: 'Подарочному коду',
    ACC: 'Подарочный код',
    INS: 'Подарочным кодом',
    PRE: 'Подарочном коде',
  },
  GOOGLE_PLAY: 'Google Play',
  ITUNES: 'iTunes',
  PAYPAL: 'PayPal',
  SMS: 'SMS',
  YANDEX_MONEY: {
    NOM: 'Яндекс.Деньги',
    GEN: 'Яндекс.Денег',
    DAT: 'Яндекс.Деньгам',
    ACC: 'Яндекс.Деньги',
    INS: 'Яндекс.Деньгами',
    PRE: 'Яндекс.Деньгах',
  },
};

export const PAYMENTS_DATA_SET = 'PAYMENTS_DATA_SET';

export const PAYMENTS_PRICE = {
  standardPerMonth: 199,
};

export const SUBSCRIPTION_FOOTER_TEXTS = {
  pro: 'Новинки, бизнес-литература, книги<br />по саморазвитию и аудиокниги',
  standard: 'В подписку не входят свежие поступления<br /> книг, бизнес-книги и аудиокниги',
};
